import { TopPartElement } from "@/custolink-views/asset_frontend/ui/TopPartElement";
import { FaRobot } from "react-icons/fa";

export default function AiSupportUiButton(p:{
  onClick: () => void,
  text: string
}) {
  return <TopPartElement
    icon={<FaRobot className={"text-xl text-primary"} />}
    onClick={() => {
      p.onClick()
    }}
  >
    <div className={"text-center"}>{p.text}</div>
  </TopPartElement>
}
